import React from 'react';
import styled from 'styled-components';
import InputTip from 'components/atoms/form/InputTip';
import { get } from 'lodash';

const Wrapper = styled.div`
    margin: 5px 0px 5px 0px;
`;

const ImagePreviewWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-content: center;
    margin-bottom: 5px;

    img {
        max-width: 100%;
        max-height: 200px;
    }
`;

const RemoveLogoButton = styled.div`
    color: ${props => props.theme.colors.flamepea};
    cursor: pointer;
`;

class FileInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            logoUrl: this.props.logoUrl,
            uploadedImage: ''
        };
        this.removeLogo = this.removeLogo.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const nextLogoUrl = nextProps.logoUrl;
        let nextState = null;
        if (nextLogoUrl !== prevState.logoUrl) {
            nextState = {
                logoUrl: nextLogoUrl,
                uploadedImage: ''
            };
        }

        return nextState;
    }

    removeLogo() {
        this.setState({
            uploadedImage: null
        });
        this.props.input.onChange(null);
        this.props.logoCallback(null, true);
        this.refs.fileInput.value = null;
    }

    handleImageChange(e) {
        const acceptableFileTypes = ['jpg', 'jpeg', 'png', 'gif'];
        e.preventDefault();
        const reader = new FileReader();
        const file = e.target.files[0];
        const fileName = get(e.target.files[0], 'name', null);
        const fileExt = fileName ? fileName.split('.').pop().toLowerCase() : null;

        if (fileExt && acceptableFileTypes.includes(fileExt)) {
            reader.onloadend = () => {
                this.setState({
                    uploadedImage: reader.result
                });
                this.props.logoCallback(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            alert(`${fileExt.toUpperCase()} files are not supported. Please use PNG, JPG, JPEG, or GIF.`); // eslint-disable-line no-alert
            this.removeLogo();
        }
        // this is in case someone hits cancel on the file reader
        if (typeof file === 'undefined') {
            this.removeLogo();
        }
    }

    render() {
        const { input, type } = this.props;
        const hasLogo = this.state.uploadedImage || this.state.logoUrl;
        delete input.value;

        return (
            <Wrapper>
                <ImagePreviewWrapper>
                    <img src={ this.state.uploadedImage || this.state.logoUrl } />
                    {hasLogo && <RemoveLogoButton onClick={this.removeLogo} className='icon-close-circle' />}
                </ImagePreviewWrapper>
                <br />
                <label htmlFor={input.name}>
                    <input {...input} type={type} ref="fileInput" onChange={(e) => {
                        input.onChange();
                        this.handleImageChange(e);
                    }}/>
                </label>
                <br />
                <InputTip>
                    <ul>
                        <li>PNG, JPG, or GIF accepted. (Best result use a PNG or JPG)</li>
                        <li>Image scales automatically to a maximum of 230x80 pixels.</li>
                        <li>Please keep the file size as small as possible. </li>
                    </ul>
                </InputTip>
            </Wrapper>
        );
    }
}

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/atoms/inputs/FileInput.js